import ChevronLeft from "@/assets/ChevronLeft.svg";
import ChevronRight from "@/assets/ChevronRight.svg";
import clsx from "classnames";
import { chunk } from "lodash";
import { Carousel, Col, Container, Row, Stack } from "react-bootstrap";
import classes from "./styles.module.scss";
import QuoteMarks from "@/assets/QuoteMarks.svg";

const BlockQuoteCards = ({ className, items, visibleCount }) => (
  <Row className={clsx(className, { "h-100 px-4": visibleCount > 1 })}>
    {items.map(({ quote, authorName, authorPosition }, k) => (
      <Col key={k}>
        <blockquote className={clsx(className, classes.card, "p-4")}>
          <Stack className="flex-row mb-3" gap={3}>
            <div>
              <QuoteMarks />
            </div>
            <section dangerouslySetInnerHTML={{ __html: quote }} />
          </Stack>

          <cite>
            <b dangerouslySetInnerHTML={{ __html: authorName }} />
            <br />
            <span dangerouslySetInnerHTML={{ __html: authorPosition }} />
          </cite>
        </blockquote>
      </Col>
    ))}
  </Row>
);

export const BlockQuote = ({ className, bgColor, textColor, title, titleColor, items, carousel, visibleCount }) => {
  return (
    <div className={clsx(className, bgColor, textColor, classes.blockquotes)}>
      <Container>
        <h2 className={titleColor}>{title}</h2>
        {carousel ? (
          <Carousel
            className={classes.blockquotes__carousel}
            controls={true}
            indicators={false}
            prevIcon={<ChevronLeft width="14" height="25" />}
            nextIcon={<ChevronRight width="14" height="25" />}
          >
            {chunk(items, visibleCount).map((items, k) => (
              <Carousel.Item key={k}>
                <BlockQuoteCards items={items} visibleCount={visibleCount} />
              </Carousel.Item>
            ))}
          </Carousel>
        ) : (
          <div className="px-5">
            {chunk(items, visibleCount).map((items, k) => (
              <BlockQuoteCards key={k} items={items} visibleCount={visibleCount} />
            ))}
          </div>
        )}
      </Container>
    </div>
  );
};

export default BlockQuote;
